import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import VendorPayablesTable from 'components/modules/orders/order-rtb/VendorPayablesTable';
import formatMoney from 'utils/formatters/Money';

export default function VendorPayables({
  charges,
  total,
  shipmentId,
  shipment,
  showConfirmation,
  isLegManagementEnabled = false,
}) {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return (charges || []).map((charge) => ({
      ...charge,
      shipment: shipment
        ? { _id: shipment._id, shipment_id: shipment.shipment_id }
        : { _id: shipmentId },
      adjustment_id: charge._id,
    }));
  }, [charges, shipmentId, shipment]);

  const handleTogglePaid = useCallback(
    (item) => {
      showConfirmation(
        item._id,
        shipmentId,
        item.payment_status,
        item.message,
        formatMoney(item.value, item?.currency),
      );
    },
    [showConfirmation, shipmentId],
  );

  return (
    <div data-testid="div-99063d4c">
      <h4 data-testid="h3-a3c28987" className="text-base font-semibold mb-4">
        {t('VENDOR_CHARGES')}
      </h4>
      <div data-testid="div-6f5792f4" className="overflow-x-auto">
        <VendorPayablesTable
          items={items}
          total={total}
          isLegManagementEnabled={isLegManagementEnabled}
          onTogglePaid={handleTogglePaid}
        />
      </div>
    </div>
  );
}

VendorPayables.propTypes = {
  charges: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      value: PropTypes.number,
      type: PropTypes.string,
      message: PropTypes.string,
      timestamp: PropTypes.string,
    }),
  ),
  total: PropTypes.number,
  shipmentId: PropTypes.string,
  shipment: PropTypes.shape({
    _id: PropTypes.string,
    shipment_id: PropTypes.string,
  }),
  showConfirmation: PropTypes.func,
  isLegManagementEnabled: PropTypes.bool,
};

VendorPayables.defaultProps = {
  total: 0,
  isLegManagementEnabled: false,
};
